import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import Config from '../../../config/Config';
import { RestauInfoContext } from '../../../home/RestauInfoContext';
import axios from 'axios';
import PrintStations from '../components/PrintStations';

export default function PrintStationsAtFoodItem(props) {
    const { openFood } = props;
    const { restauHook } = useContext(RestauInfoContext);
    const [openDialogToAssignStations, setopenDialogToAssignStations] =
        useState(false);
    const [itemStationMapping, setItemStationMapping] = useState({});
    const [loading, setLoading] = useState(false);

    async function loadData() {
        //debugger;
        //console.log(props.openFood);
        setLoading(true);
        const token = await window.customerApp.auth().currentUser.getIdToken();
        var config = {
            headers: {
                token: token,
                'Content-Type': 'application/json',
            },
        };

        let reqBody = {
            restauId: restauHook.restauId,
            categoryId: openFood.value.sectionId,
            foodItemId: openFood.value.food.id,
        };

        //function to fetch the popularitems from databasse
        let response = await axios
            .post(Config.getStationMappingForFoodItem, reqBody, config)
            .catch(function (error) {
                console.log(error);
            });
        if (response && response.data) {
            //console.log('Response>>: ' + JSON.stringify(response.data));
            if (response.data && response.data.status === undefined) {
                //setPopularItemData([...response.data]);
                setItemStationMapping({ ...response.data });
            } else {
                setItemStationMapping({});
            }
        }
        setLoading(false);
    }

    async function handleStationMappingUpdate(itemStationMappingToUpdate) {
        // console.log(
        //     'Station Mapping to update in db: ',
        //     itemStationMappingToUpdate
        // );
        setItemStationMapping({ ...itemStationMappingToUpdate });
        let stationNamesToMap = Object.values(itemStationMappingToUpdate)
            .filter((fd) => fd.isMapped)
            .map((x) => x.name);
        //console.log('Stations to update in db: ', stationNamesToMap);
        //props.openFood.value.food.station = [...stationNamesToMap];
        let val = openFood.value;
        val.food.station = [...stationNamesToMap];
        openFood.setValue(val);
    }

    useEffect(() => {
        console.log(openFood);
        loadData();
    }, []);

    return (
        <PrintStations
            openDialogToAssignStations={openDialogToAssignStations}
            setopenDialogToAssignStations={setopenDialogToAssignStations}
            handleStationMappingUpdate={handleStationMappingUpdate}
            stationMappingData={itemStationMapping}
            loading={loading}
        />
    );
}

PrintStationsAtFoodItem.propTypes = {
    openFood: PropTypes.shape({
        value: PropTypes.shape({
            food: PropTypes.shape({
                id: PropTypes.string,
                station: PropTypes.string,
            }),
            sectionId: PropTypes.string,
        }),
        setValue: PropTypes.func,
    }),
};
